/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Companion World API
 * API for managing virtual worlds populated with AI-driven agents.

## Overview
The Companion World API provides endpoints for:
- Creating and managing virtual worlds
- Generating populations of AI agents
- Managing agent activities and calendars
- Configuring locations and demographics

## Authentication
Currently, the API operates without authentication. This will be updated in future versions.

## Async Operations
Long-running operations (like population generation) return job IDs for status polling.

 * OpenAPI spec version: 1.0.0
 */

/**
 * Agent's review status (only when include_review=true)
 */
export type AgentReviewStatus = (typeof AgentReviewStatus)[keyof typeof AgentReviewStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentReviewStatus = {
  pending: 'pending',
  locked_for_review: 'locked_for_review',
  approved: 'approved',
  rejected: 'rejected',
  needs_changes: 'needs_changes',
} as const;
